import { render, staticRenderFns } from "./dialogMessage.vue?vue&type=template&id=2c7fad7d&"
import script from "./dialogMessage.vue?vue&type=script&lang=js&"
export * from "./dialogMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports